module.exports = __webpack_public_path__ + "static/media/01_oldsize_Line.dccd55f2.jpg";